import React from 'react';
import { Layout, Button } from 'antd';
import './AppHeader.css';
import MyLogo from '../../../images/gd-icon.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthService from '../../../services/AuthService.ts';

const { Header } = Layout;

const HeaderComponent: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoginPage = location.pathname === "/login";

  const company = localStorage.getItem("company");

  const handleLogout = async () => {
    let authservice = AuthService.getInstance()
    await authservice.logout();
    navigate("/login", { replace: true });
  };

  return (
    <Header className="header">
      <div className="logo-container">
        <img src={MyLogo} className="header-logo" alt="Logo" />
      </div>
      <h1 className="header-title">FlashCapture Manager</h1>
      {!isLoginPage && (
        <div className="header-actions">
          <span className="company-name">
            {company}
          </span>
          <Button type="link" className="logout-button" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      )}
    </Header>
  );
};

export default HeaderComponent;
